import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/spaces/$spaceId')({
  component: SpaceLayout,
});

function SpaceLayout() {
  return <Outlet />;
}
